export default __webpack_public_path__ + "static/media/Claros_logo.9d725250.png";